{
  "title": "Agarang abiso sa buong bayan",
  "lead": "Para sa mga emergency at abalang kailangang malaman ng lahat ngayon. Aabot ang abiso sa bawat residente, anuman ang sinusundan nila, at mangunguna ito sa home feed.",
  "notAllowed": "Hindi puwedeng magpadala ng agarang abiso sa buong bayan ang opisinang ito. Tanungin ang LGU administrator kung dapat itong payagan.",
  "viewerNote": "Makikita mo ang mga abisong ipinadala ng opisinang ito. Ang mga editor at office head ang puwedeng magpadala ng bago.",
  "ordinaryNote": "Hindi agaran? Mag-post na lang ng karaniwang anunsyo; aabot ito sa mga sumusunod sa inyong opisina.",
  "composeTitle": "Bagong agarang abiso",
  "alertTitle": "Pamagat",
  "alertTitleHint": "Maikli at malinaw, hal. \"Walang pasok bukas, lahat ng antas\".",
  "message": "Mensahe",
  "messageHint": "Ang kailangang malaman o gawin ng mga tao. Paikliin para magkasya sa text message.",
  "smsCount": "{chars} karakter · {parts} SMS",
  "smsUnicode": "May mga karakter na nagpapaikli sa bawat SMS (70 sa halip na 160). Iwasan ang emoji at kulot na panipi.",
  "smsLong": "Pinuputol ang text message pagkalampas ng 3 SMS. Paikliin ang mensahe kung kaya.",
  "link": "Link sa post na may detalye",
  "linkNone": "Walang link",
  "linkHint": "Halimbawa, ang buong advisory. Nakalista ang mga nailathalang post ng opisinang ito.",
  "duration": "Panatilihin sa itaas ng feed nang",
  "duration_6": "6 na oras",
  "duration_24": "24 na oras",
  "duration_72": "3 araw",
  "duration_none": "Hanggang i-archive ng isang editor",
  "channels": "Paano ipapadala",
  "channelPush": "Notification sa app sa bawat residente",
  "channelPushHint": "{residents} residente · {devices} telepono na naka-on ang notification",
  "channelPushOff": "Hindi pa naka-set up ang notification sa telepono. Makikita ng mga residente ang abiso sa app at sa kanilang inbox.",
  "channelSms": "Magpadala rin ng text message (SMS)",
  "channelSmsHint": "Sa {count} residenteng may mobile number na hindi nag-off ng SMS alert. May bayad para sa LGU ang bawat text message.",
  "smsNotConfigured": "Hindi naka-set up ang SMS (SEMAPHORE_API_KEY), kaya walang text message na maipapadala. Tuloy pa rin ang notification sa app.",
  "review": "Suriin at ipadala",
  "reviewTitle": "Ipadala ang agarang abisong ito?",
  "reviewReach": "Aabot ito ngayon sa {residents} residente at mananatili sa itaas ng home feed.",
  "reviewSms": "May text message na ipapadala sa {count} mobile number.",
  "reviewNoSms": "Walang text message na ipapadala.",
  "smsPreview": "Text message",
  "pushPreview": "Notification sa app",
  "confirmSms": "Nauunawaan kong {count} text message ang ipapadala at hindi na ito mababawi.",
  "send": "Ipadala na ang abiso",
  "sending": "Ipinapadala…",
  "back": "Bumalik sa pag-edit",
  "sent": "Naipadala ang abiso sa {residents} residente.",
  "sentSms": "Naipadala ang abiso. Ipinapadala na ang text message sa {count} numero.",
  "historyTitle": "Mga naipadalang abiso",
  "historyEmpty": "Wala pang naipadalang agarang abiso.",
  "sentBy": "Ipinadala {date} ni {name}",
  "sentAt": "Ipinadala {date}",
  "reach": "{count} residente ang naabisuhan",
  "pushed": "{count} telepono",
  "smsSent": "{count} SMS naipadala",
  "smsFailed": "{count} SMS hindi naipadala",
  "smsNotSent": "Hindi naka-set up ang SMS: {count} hindi naipadala",
  "delivering": "Ipinapadala pa…",
  "active": "Nasa itaas ng feed",
  "until": "hanggang {date}",
  "ended": "Wala na sa itaas",
  "viewPost": "Tingnan",
  "editPost": "I-edit o i-archive",
  "urgent": "Agaran",
  "titleRequired": "Sumulat ng pamagat na hindi bababa sa 5 karakter.",
  "messageRequired": "Sumulat ng mensaheng hindi bababa sa 10 karakter.",
  "sentNoSms": "Hindi naka-set up ang SMS, kaya walang naipadalang text message."
}
